<template>
  <div class="main-container minh-100">
    <div class="main-content-wrap">
      <div class="company-gig-side flex flex-col items-center justify-content-center">
        <h3>Solve Your IT Problems</h3>
      </div>
      <div class="company-gig-main tech-apply-main flex-1">
        <div class="company-gig-step">
          <div class="top-desc">
            Thank you for considering using ScaleDesk for your IT project needs! Here are a few quik questions so we can better understand what your requirements are.
          </div>
          <h3>What type of project is this?</h3>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-type"><div class="m-radio"></div>One time IT project</label>
            </div>
            <p>
              You need one of our IT destop, networking, security, or systems tech for a one time project
            </p>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-type"><div class="m-radio"></div>Recurring IT consultant(Full time/Part time)</label>
            </div>
            <p>If you need a long term consultant, part-time, or full-time for any IT functionality</p>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-type"><div class="m-radio"></div>Full-time employee</label>
            </div>
            <p>Source you next full-time employee from our network, either via referral or a contract to hire</p>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-type"><div class="m-radio"></div>Remote Managed IT Helpdesk</label>
            </div>
            <p>A solution to outsource your IT helpdesk to us, including tasks like support and onboarding/deboarding</p>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-type"><div class="m-radio"></div>Unsure</label>
            </div>
          </div>
          <div class="company-gig-footer flex flex-row ">
            <div class="flex-1">
              <button type="button" class="btn-link">
                <i class="material-icons-outlined align-middle">chevron_left</i> Back
              </button>
            </div>
            <div class="flex-1 text-right">
              <button type="button" class="btn-blue">
                Next
              </button>
            </div>
          </div>
        </div>
        <div class="company-gig-step">
          <h3>How long is the project?</h3>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-duration"><div class="m-radio"></div>Less than 1 week</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-duration"><div class="m-radio"></div>1 to 4 weeks</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-duration"><div class="m-radio"></div>1 to 3 month</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-duration"><div class="m-radio"></div>3 to 6 month</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project-duration"><div class="m-radio"></div>Unsure</label>
            </div>
          </div>
          <div class="company-gig-footer flex flex-row ">
            <div class="flex-1">
              <button type="button" class="btn-link">
                <i class="material-icons-outlined align-middle">chevron_left</i> Back
              </button>
            </div>
            <div class="flex-1 text-right">
              <button type="button" class="btn-blue">
                Next
              </button>
            </div>
          </div>
        </div>
        <div class="company-gig-step">
          <h3>How long do you need our onsultant?</h3>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant-duration"><div class="m-radio"></div>3 to 6 month</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant-duration"><div class="m-radio"></div>6 month to 1 year</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant-duration"><div class="m-radio"></div>1 year+</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant-duration"><div class="m-radio"></div>Ongoing</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant-duration"><div class="m-radio"></div>Unsure</label>
            </div>
          </div>
          <div class="company-gig-footer flex flex-row ">
            <div class="flex-1">
              <button type="button" class="btn-link">
                <i class="material-icons-outlined align-middle">chevron_left</i> Back
              </button>
            </div>
            <div class="flex-1 text-right">
              <button type="button" class="btn-blue">
                Next
              </button>
            </div>
          </div>
        </div>
        <div class="company-gig-step">
          <h3>What type of employee are you looking for?</h3>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="employee"><div class="m-radio"></div>Desktop Support</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="employee"><div class="m-radio"></div>Networking</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="employee"><div class="m-radio"></div>System Administration</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="employee"><div class="m-radio"></div>Business Application Related(SAP, Netsuite, Okta, Salesforce, Etc)</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="employee"><div class="m-radio"></div>Other</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="company-gig-footer flex flex-row ">
            <div class="flex-1">
              <button type="button" class="btn-link">
                <i class="material-icons-outlined align-middle">chevron_left</i> Back
              </button>
            </div>
            <div class="flex-1 text-right">
              <button type="button" class="btn-blue">
                Next
              </button>
            </div>
          </div>
        </div>
        <div class="company-gig-step">
          <h3>What type of consultant are you looking for?</h3>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant"><div class="m-radio"></div>Desktop Support</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant"><div class="m-radio"></div>Networking</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant"><div class="m-radio"></div>System Administration</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant"><div class="m-radio"></div>Business Application Related(SAP, Netsuite, Okta, Salesforce, Etc)</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="consultant"><div class="m-radio"></div>Other</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of who you are looking for and what skills they should have. If you have a link to a job Description you can link this." />
            </div>
          </div>
          <div class="company-gig-footer flex flex-row ">
            <div class="flex-1">
              <button type="button" class="btn-link">
                <i class="material-icons-outlined align-middle">chevron_left</i> Back
              </button>
            </div>
            <div class="flex-1 text-right">
              <button type="button" class="btn-blue">
                Next
              </button>
            </div>
          </div>
        </div>
        <div class="company-gig-step">
          <h3>What type of project do you want us to work on?</h3>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project"><div class="m-radio"></div>It Office Move</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of what you are looking to do and what skills techs should have." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project"><div class="m-radio"></div>Imaging/Migration/Iventory</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of what you are looking to do and what skills techs should have." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project"><div class="m-radio"></div>Networking</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of what you are looking to do and what skills techs should have." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project"><div class="m-radio"></div>System Administration</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of what you are looking to do and what skills techs should have." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project"><div class="m-radio"></div>Business Application Related(SAP, Netsuite, Okta, Salesforce, Etc)</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of what you are looking to do and what skills techs should have." />
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="project"><div class="m-radio"></div>Other</label>
            </div>
            <div class="radio-desc">
              <textarea rows="3" placeholder="Put a short description of what you are looking to do and what skills techs should have." />
            </div>
          </div>
          <div class="company-gig-footer flex flex-row ">
            <div class="flex-1">
              <button type="button" class="btn-link">
                <i class="material-icons-outlined align-middle">chevron_left</i> Back
              </button>
            </div>
            <div class="flex-1 text-right">
              <button type="button" class="btn-blue">
                Next
              </button>
            </div>
          </div>
        </div>
        <div class="company-gig-step">
          <h3>Please tell us more about you and your company:</h3>
          <p>Your name</p>
          <div class="form-inline">
            <div class="flex inline-input">
              <div class="flex-1">
                <input type="text" placeholder="Your Name"></div>
              <div class="flex-1">
                <input type="text" placeholder="Company Name"></div>
            </div>
          </div>
          <div class="form-inline">
            <div>
              <input type="email" placeholder="Email">
            </div>
          </div>
          <p>Your Company Size:</p>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="company-size"><div class="m-radio"></div>Less than 10</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="company-size"><div class="m-radio"></div>10-50</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="company-size"><div class="m-radio"></div>51-200</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="company-size"><div class="m-radio"></div>201-1000</label>
            </div>
          </div>
          <div class="form-inline block-radio">
            <div>
              <label><input type="radio" name="company-size"><div class="m-radio"></div>More than 1000</label>
            </div>
          </div>
          <div class="company-gig-footer flex flex-row ">
            <div class="flex-1">
              <button type="button" class="btn-link">
                <i class="material-icons-outlined align-middle">chevron_left</i> Back
              </button>
            </div>
            <div class="flex-1 text-right">
              <button type="button" class="btn-blue">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";
export default {
  data() {
    return {
      submitSuccess: false,
      submitLoading: false,
    }
  },
  components: {
    spinnerButton
  },
}
</script>

<style scoped>

</style>
